import { camelizeKeys } from '@skytech/utils'

import type {
  Termination,
  TerminationPayload,
  TerminationSetup,
} from '@/modules/subscriptions/termination/types'
import {
  API_ROUTE_TERMINATION,
  API_ROUTE_TERMINATION_CANCEL,
  API_ROUTE_TERMINATION_LIST,
  API_ROUTE_TERMINATION_RESEND_FORM,
  API_ROUTE_TERMINATION_SETUP,
} from '@/resources/api-routes'
import { get, post } from '@/util/auth'

const terminationResources = {
  getList: async () => {
    const terminations = await get<unknown>(API_ROUTE_TERMINATION_LIST)
    const parsedTerminations = camelizeKeys(terminations) as Termination[]

    return parsedTerminations as Termination[]
  },
  get: async (id: number) => {
    const termination = await get(API_ROUTE_TERMINATION.replace(':terminationOrderId', String(id)))
    const parsedTermination = camelizeKeys(termination) as Termination[]
    return parsedTermination[0]
  },

  getSetup: async () => {
    const setup = await get<unknown>(API_ROUTE_TERMINATION_SETUP)
    const parsedSetup = camelizeKeys(setup)
    return parsedSetup as TerminationSetup
  },

  // mutations
  post: async (payload: TerminationPayload) => post(API_ROUTE_TERMINATION_LIST, payload),

  resendForm: async (orderId: number, payload: { email: string; replace_email: boolean }) =>
    post(API_ROUTE_TERMINATION_RESEND_FORM.replace(':orderId', String(orderId)), payload),

  cancelTerminationOrder: async (id: number, comment: string) => {
    const order = await post<boolean>(
      API_ROUTE_TERMINATION_CANCEL.replace(':subscriptionId', String(id)),
      {
        comment,
      },
      true
    )
    return order
  },
}

export default terminationResources
